export const getters = {
  getModalViewDiscountCoupon: state => state.modalViewDiscountCoupon,
  getDiscountCoupons: state => state.discountCoupons,
  getDiscountCoupon: state => state.discountCoupon
};

export default {};
